import React from 'react'
import { Timeline, Typography, Button, Row, Col } from 'antd'
import moment from 'moment'

import { Formik } from 'formik'
import { Form, Input } from 'formik-antd'
import * as Yup from 'yup'
import { EditOutlined, CommentOutlined, BankOutlined, DollarOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { v4 } from 'uuid'
import { DATETIME_FORMAT } from '../../core/utils/i18n-js'

import PropTypes from 'prop-types'
const { Text } = Typography

const messageSchema = Yup.object().shape({
  content: Yup.string().required('Cannot be blank'),
})

const Editor = ({ handleSubmit, message }) => (
  <Formik initialValues={{ content: message }} validationSchema={messageSchema} onSubmit={handleSubmit}>
    {({ isSubmitting, submitForm }) => (
      <Form>
        <Row gutter={0}>
          <Col flex='auto'>
            <Form.Item name='content' label='' required>
              <Input.TextArea xstyle={{ width: 'calc(100% - 200px)' }} name='content' rows={1} required />
            </Form.Item>
          </Col>
          <Col flex='200px'>
            <Button type='primary' loading={isSubmitting} onClick={submitForm}>
              Send
            </Button>
          </Col>
        </Row>
      </Form>
    )}
  </Formik>
)

const Bitacora = ({ handleSubmit, bitacora }) => {
  const _handleSubmit = (values, bag) => {
    let form = {
      ...values
    }

    if (!values.id) {
      form = {
        id: v4(),
        ...form
      }
    }

    handleSubmit(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        bag.resetForm()
      },
      onError: () => {
        bag.setSubmitting(false)
        /* if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
        */
      }
    })

  }

  const getCategoryIcon = (category) => {
    if (category === 'price') return <DollarOutlined />

    if (category === 'comment') return <CommentOutlined />

    if (category === 'payment') return <BankOutlined />

    if (category === 'deadline') return <ClockCircleOutlined />

    return <EditOutlined />
  }
  const timeline = (bitacora || []).slice().reverse()

  return (
    <Timeline mode='left'>
      <Timeline.Item>
        <Editor handleSubmit={_handleSubmit} message='' />
      </Timeline.Item>
      {timeline.map((item) => {
        // const time = moment(item.datetime).fromNow()
        return (
          <Timeline.Item dot={getCategoryIcon(item?.category)} key={item.id.toString()}>
            <p style={{ marginBottom: 0 }}>
              <Text underline>{item.userName}</Text> <Text type='secondary'>{moment(item.datetime).format(DATETIME_FORMAT)}</Text> 
            </p>
            <p style={{ marginBottom: 0 }}>{item.title}</p>
          </Timeline.Item>
        )
      })}
    </Timeline>
  )
}

Bitacora.propTypes = {
  bitacora: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      userId: PropTypes.string.isRequired,
      userName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      datetime: PropTypes.number.isRequired
    })
  )
}
/*
<Text type='secondary'>{time}</Text>{' '}
              
*/

export default Bitacora
